import React from 'react'
import { RealEstateDataPageComponentData } from 'types'
import DevelopmentAbout from '../1'

const DevelopmentAbout2 = ({
  developmentID,
  global_data,
  titleElement,
  is_short,
  title,
  hidden,
  subtitle,
  button,
}: { developmentID: string } & RealEstateDataPageComponentData) => {
  return (
    <DevelopmentAbout
      developmentID={developmentID}
      global_data={global_data}
      titleElement={titleElement}
      is_short={is_short} //Concepto hidden??
      hidden={hidden} //Descripción hidden??
      button={button}
      title={title}
      subtitle={subtitle}
    />
  )
}

export default DevelopmentAbout2
